import { useState, useEffect } from "react";
import { Button, Checkbox, Col, Descriptions, Divider, Form, Input, Modal, notification, Row, Table } from "antd";
import { CloseOutlined, DeleteOutlined, ExclamationCircleOutlined, PlusOutlined, WhatsAppOutlined } from "@ant-design/icons";
import moment from 'moment';

import ModalImagemQr from "../modalImagemQr";
import { useStateValue } from "../../../state";
import { formatarCpf, isObjetoDiffVazio } from "../../../services/funcoes";
import { listagemActions } from "../../../actions";
import api from "../../../services/api";
import { FormatFone, FormatNumber } from "../../../ValueObjects";
import InputPhone from "../../inputPhone";

export default function ModalEnvioNFeWhats({ exibirModalEnvioNFeWhats, fecharModalEnvioNFeWhats }) {
    const [{ manutencao }, dispatch] = useStateValue();
    const [dadosNota, setDadosNota] = useState({});
    const [listaWhats, setListaWhats] = useState([]);
    const [form] = Form.useForm();
    const [base64Image, setBase64Image] = useState('');
    const [conectado, setConectado] = useState(false);
    const [exibirQr, setExibirQR] = useState(false);
    const [temporizador, setTemporizador] = useState(60);
    const [enviaNota, setEnviaNota] = useState(false);
    const [enviaXml, setEnviaXml] = useState(false);
    const [carregando, setCarregando] = useState(false);

    useEffect(() => {
        if (!!manutencao.dados && isObjetoDiffVazio(manutencao.dados)) {
            retornaDadosCliente(manutencao.dados.pes_id);
            setDadosNota(manutencao.dados);
            conectar();
        }
    }, [manutencao.dados]);

    useEffect(() => dispatch({ type: listagemActions.CHANGE, data: { ordem: '+dest' } }), []);

    const onCloseModal = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                setListaWhats([]);
                form.resetFields();
                fecharModalEnvioNFeWhats();
            }
        });
    };

    const onCloseModalQr = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                setExibirQR(false);
                setTemporizador(temporizador);

            }
        });
    };

    async function enviarWhats() {
        let dados = {};
        let numero = [];
        listaWhats.forEach((Whats) => {
            numero.push(Whats.dest);
        })
        dados.ntf_id = dadosNota.ntf_id;
        dados.chaveNFe = dadosNota.ntf_chavenfe;
        dados.numeroDestinatarios = numero;
        let whats = {
            Id: dadosNota.ntf_id,
            ChaveAcesso: dadosNota.ntf_chavenfe,
            numerosReceptor: numero,
            enviaNota: enviaNota,
            enviaBoleto: false,
            enviaXml: enviaXml,
            //extensao: 'pdf', //podera ser utilizado no futuro para enviar o arquivo em formatos alem de pdf
            mensagem: form.getFieldValue().mensagem
        };
        /// numero da empresa deve ser um numero com codigo de area mais numero de telefone com 8 digitos
        if (conectado === true && (!!!numero || numero.length > 0)) {
            enviarDados(whats);
        }
        else if (!numero || numero.length === 0 && conectado === false) {
            notification.Alert({ description: 'Adicione um ou mais numeros de remetente!', message: 'Aviso' });
            return;
        }
        else if (conectado === false && !!!numero || numero.length > 0) {
            gerarQRCode(whats);
        }
    }

    async function gerarQRCode(whats) {
        let base64 = (await api.get(`WhatsApp/GeraQrCodeWhats`)).data; // Pode passar qualquer string aqui
        setExibirQR(true);
        setBase64Image(base64);  // Atualiza o estado com o QR Code
        verificarConexao(whats);
    }

    async function conectar() {
        let conectar = (await api.get('WhatsApp/WhatsConectado')).data;
        setConectado(conectar);
        return conectar;
    }

    async function verificarConexao(whats) {
        const timeout = Date.now() + (temporizador * 1000); // Define o tempo limite em segundos
        while (Date.now() < timeout) {
            let status = await conectar();
            if (status === true) {
                setExibirQR(false);
                console.log("Conectado!");
                enviarDados(whats);
                notification.success({ description: 'Conectado!', message: 'Aviso' });
                return;
            }
            await new Promise((resolve) => setTimeout(resolve, 4500)); // Aguarda 4,5s antes de tentar novamente
        }
        gerarQRCode(); // Chama a função para gerar um novo QR Code
    }


    async function enviarDados(whats) {
        setCarregando(true);
        var url = "NotaFiscal/EnviarWhats";
        api.post(url, whats).then(
            (res) => {
                notification.success({ description: 'Nota enviada com sucesso!', message: 'Aviso' });
            }
        ).catch(
            (erro) => {
                setCarregando(false);
                console.log(erro);
            }
        ).finally(
            () => {
                setCarregando(false);
                fecharModalEnvioNFeWhats();
                form.resetFields();
                setListaWhats([]);
            }
        );
        form.resetFields();
    }

    async function retornaDadosCliente(dados) {
        if (!!dados) {
            let clienteTelefone = (await api.get(`PessoaTelefone/ListaTelefone?IdPessoa=` + dados)).data;
            let telefoneWhats = clienteTelefone.find(telefone => telefone.psc_whatsapp === true);
            let lista = [];
            if (telefoneWhats?.psc_numero !== null && telefoneWhats?.psc_numero !== undefined) {
                lista.push({ id: lista.length, dest: telefoneWhats?.psc_numero });
            }
            setListaWhats(lista);
        }
    }

    function adicionarWhats() {
        let numero = form.getFieldValue().numeroWhats;
        if (!!numero) {
            let lista = [...listaWhats];
            lista.push({ id: lista.length, dest: numero });
            setListaWhats(lista);
            form.setFieldsValue({ numeroWhats: null });
        }
    };

    function excluirWhats(record) {
        let listaE = [...listaWhats];
        let WhatsLista = listaE.filter((lista) => (lista.id !== record.id));
        setListaWhats(WhatsLista);
    };

    function handleEnviaNota() {
        setEnviaNota(!enviaNota);
    }

    function handleEnviaXml() {
        setEnviaXml(!enviaXml);
    }

    return (
        <Modal centered
            title="Enviar NF-e/NFC-e por WhatsApp"
            open={exibirModalEnvioNFeWhats}
            confirmLoading={carregando}
            onCancel={onCloseModal}
            onOk={enviarWhats}
            okText={
                <>
                    <WhatsAppOutlined /> Enviar WhatsApp
                </>
            }
            cancelText={
                <>
                    <CloseOutlined /> Cancelar
                </>
            }
            maskClosable={false}
        >
            <div>
                <div>
                    <Descriptions size="small">
                        <Descriptions.Item label="Chave de Acesso">
                            <b>{dadosNota.ntf_chavenfe}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="Nº Doc. Fiscal">
                            <b>{dadosNota.ntf_numero}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="Série">
                            <b>{dadosNota.ser_serie}</b>
                        </Descriptions.Item>
                        <Descriptions.Item label="Emissão">
                            <b>{!!dadosNota.ntf_dataemissao ? moment(dadosNota.ntf_dataemissao).format('DD/MM/YYYY') : null}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="Valor (R$)">
                            <b>{!!dadosNota.valor_total ? FormatNumber(dadosNota.valor_total, true) : null}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="Destinatário">
                            <b>{dadosNota.ntf_nomedest}</b>
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small">
                        <Descriptions.Item label="CPF/CNPJ">
                            <b>{!!dadosNota.ntf_cnpjcpfdest ? formatarCpf(dadosNota.ntf_cnpjcpfdest) : ''}</b>
                        </Descriptions.Item>
                    </Descriptions>
                </div>
                <div style={{ display: "flex", gap: "16px" }}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <Form.Item name="enviaNota" valuePropName="enviaNota" >
                            <Checkbox onChange={(value) => { handleEnviaNota(value) }}>Enviar Nota Fiscal? </Checkbox>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <Form.Item name="enviaXml" valuePropName="enviaXml" >
                            <Checkbox onChange={(value) => { handleEnviaXml(value) }}>Enviar XML? </Checkbox>
                        </Form.Item>
                    </Col>
                </div>
                <Form layout="vertical" form={form} >
                    <Col >
                        <Form.Item label="Mensagem" name="mensagem">
                            <Input placeholder="Mensagem de texto que sera enviado" />
                        </Form.Item>
                    </Col>
                </Form>
                <Form layout="vertical" form={form} className="m-t-8">
                    <Row gutter={[8, 0]}>
                        <Col xs={24} sm={16} md={18} lg={18} xl={18}>
                            <InputPhone label="N° de Telefone do Destinatário" name="numeroWhats" placeholder="N° de Telefone do Destinatário aqui" />
                        </Col>
                        <Col xs={24} sm={8} md={6} lg={6} xl={6} className="t-mob-573">
                            <Button type="primary" icon={<PlusOutlined />} onClick={() => adicionarWhats()} block>Adicionar</Button>
                        </Col>
                    </Row>
                </Form>
                <div className="tabela">
                    <Table columns={[
                        {
                            title: 'N° Telefone Destinatário',
                            render: ({ dest }) => (
                                <div>
                                    <b>{FormatFone(dest)}</b>
                                </div>
                            ),
                        },
                        {
                            title: 'Ações',
                            dataIndex: '',
                            key: 'x',
                            align: 'center',
                            width: 65,
                            render: (record) => (
                                <div>
                                    <Row align="middle" justify="center" gutter={[5, 0]}>
                                        <Col>
                                            <Button onClick={() => { excluirWhats(record) }} icon={<DeleteOutlined />} />
                                        </Col>
                                    </Row>
                                </div>
                            ),
                        },
                    ]} dataSource={listaWhats} locale={{
                        emptyText: (
                            <Row>
                                <Col span={24}>
                                    <Divider orientation="center">
                                        <ExclamationCircleOutlined /> Nenhum Registro Encontrado
                                    </Divider>
                                </Col>
                            </Row>
                        )
                    }} />
                </div>
            </div>
            <Modal centered
                title={`Enviar por WhatsApp`}
                open={exibirQr}
                onCancel={onCloseModalQr}
                footer={[
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button key="cancel" onClick={() => onCloseModalQr()}>
                            Cancelar
                        </Button>
                    </div>
                ]}
                width={305} // Define a largura do modal (padrão é 520px)
                bodyStyle={{ height: "320px" }} // Define a altura do corpo do modal
            >
                <ModalImagemQr centered isOpen={exibirQr} base64Image={base64Image} tempo={temporizador} />
            </Modal>
        </Modal>
    )
}